<template>
  <inventoryProductsForm :typeEndPoint="'restaurantProductsCreate'" :dataParams="{}"/>
</template>
<script>
import inventoryProductsForm from '@/components/modules/restaurant/products/form'
export default {
  name: 'inventoryProductsCreate',
  components: {
    inventoryProductsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/create.vue